<script>
    import { prefs } from "./stores";
    import { missionComplete } from "./parse";
    
    export let mission;
    export let p = false;
    export let onCard = false;
</script>

<div class="container" style="{onCard ? 'margin-top: 30%' : ''}">
    <div class="status" style="font-size: {$prefs.buttonScale * 2}vmin;">
        {#if mission.complete}
            ✅
        {:else if p && missionComplete(mission, p) == 'ready'}
            👉
        {/if}
    </div>
    {#if mission.status && !mission.complete }
        <div class="progress_meter">
            {#each Array(mission.status.count > 0 ? mission.status.count : 0) as _}
                <div class="progress_element progress_done" style="filter:hue-rotate(-{(100-mission.status.percent)/100*90}deg);"/>
            {/each}
            {#each Array(mission.status.left > 0 ? mission.status.left : 0) as _}
                <div class="progress_element progress_not_done" />
            {/each}
        </div>
    {/if}
</div>

<style>
    .container {
        position: relative;
        width: 100%;
    }

	.status {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

	.progress_meter {
        width: 100%;
        height: 1vmin;
        display: flex;
        flex-wrap: nowrap;
        position: absolute;
        bottom: 0;
        opacity: 80%;
    }

    .progress_element {
        border: 0.1px solid black;
        width: 100%;
    }

    .progress_done {
        background-color: green;
        
    }

    .progress_element + .progress_element {
        border-left: none;
    }

    .progress_not_done {
        background-color: white;
    }
</style>